export default {
    name: 'Namn',
    tel: 'Telefon',
    save: 'Spara',
    confirm: 'Bekräfta',
    cancel: 'Avbryt',
    delete: 'Radera',
    complete: 'Slutför',
    loading: 'Laddar...',
    telEmpty: 'Vänligen fyll i telefonnummer',
    nameEmpty: 'Vänligen fyll i namn',
    nameInvalid: 'Felaktigt namnformat',
    confirmDelete: 'Är du säker på att du vill radera?',
    telInvalid: 'Felaktigt telefonnummer',
    vanCalendar: {
      end: 'Slut',
      start: 'Start',
      title: 'Kalender',
      startEnd: 'Start/Slut',
      weekdays: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      monthTitle: (year, month) => `${year}/${month}`,
      rangePrompt: (maxRange) => `Välj max ${maxRange} dagar`,
    },
    vanCascader: {
      select: 'Välj',
    },
    vanContactCard: {
      addText: 'Lägg till kontaktinformation',
    },
    vanContactList: {
      addText: 'Lägg till ny kontakt',
    },
    vanPagination: {
      prev: 'Föregående',
      next: 'Nästa',
    },
    vanPullRefresh: {
      pulling: 'Dra för att uppdatera...',
      loosing: 'Släpp för att uppdatera...',
    },
    vanSubmitBar: {
      label: 'Totalt：',
    },
    vanCoupon: {
      unlimited: 'Obegränsad',
      discount: (discount) => `${discount * 10}% rabatt`,
      condition: (condition) => `Minst ${condition}`,
    },
    vanCouponCell: {
      title: 'Kupong',
      tips: 'Inga kuponger',
      count: (count) => `Du har ${count} kuponger`,
    },
    vanCouponList: {
      empty: 'Inga kuponger',
      exchange: 'Byt',
      close: 'Stäng',
      enable: 'Tillgänglig',
      disabled: 'Otillgänglig',
      placeholder: 'Kupongkod',
    },
    vanAddressEdit: {
      area: 'Område',
      postal: 'Postnummer',
      areaEmpty: 'Välj mottagningsområde',
      addressEmpty: 'Adress får inte vara tom',
      postalEmpty: 'Felaktigt postnummer',
      defaultAddress: 'Ange som standardadress',
      telPlaceholder: 'Telefon',
      namePlaceholder: 'Namn',
      areaPlaceholder: 'Område',
    },
    vanAddressEditDetail: {
      label: 'Adress',
      placeholder: 'Adress',
    },
    vanAddressList: {
      add: 'Lägg till ny adress',
    },
  };